<i18n src="@/locales/modules/DeviceCategoryTranslate.json"></i18n>

<template>
	<el-dialog
		append-to-body
		destroy-on-close
		:before-close="setDialogHide => handleCloseDialog(setDialogHide, isFormDirty)"
		class="custom-nested-dialog"
		:title="$t(dataId ? 'UpdateCategory' : 'CreateCategory')"
		:visible.sync="isPopupActiveLocal"
	>
		<PerfectScrollbar ref="formScrollBar" class="scroll-area--data-list" :settings="settings">
			<div class="p-6">
				<!-- NAME -->
				<label for class="vs-input--label">
					{{ $t("CategoryName") }}
					<span class="text-danger">*</span>:
				</label>
				<vs-input v-model="dataName" class="w-full" name="name" :data-vv-as="$t('CategoryName')" :placeholder="`${$t('Actions.Input')} ${$t('CategoryName')}`" v-validate="'required'" />
				<span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first("name") }}</span>

				<!-- CATEGORY -->
				<div class="mt-5">
					<label for class="vs-input--label">{{ $t("ParentCategory") }}:</label>
					<v-select
						class="select-tree"
						:placeholder="`${$t('Actions.Choose')} ${$t('ParentCategory').toLowerCase()}`"
						v-model="parentCategoryId"
						:reduce="category => category.value"
						label="text"
						name="category"
						:options="categoryChoices"
					>
						<template v-slot:option="option">
							<div :class="`flex items-center pl-${option.depth > 1 ? option.depth * 2 : option.depth}`">
								<i class="mr-2 nucleo nucleo-shape-oval-3"></i>
								{{ option.text }}
							</div>
						</template>
						<span slot="no-options">{{ $t("Notify.NoMatchingOptions") }}</span>
					</v-select>
				</div>

				<!-- CATEGORY ICON -->
				<div class="mt-5">
					<label for class="vs-input--label">{{ $t("Actions.Choose") }} {{ $t("CategoryIcon") | lowerCaseFirstLetter }}:</label>
					<div class="category-icons flex flex-wrap">
						<div class="item category-icons__item flex" v-for="(item, index) in categoryIcons" :key="index">
							<input v-model="categoryIcon" :value="item.iconContent" type="radio" name="category-icon" :id="item.iconName" class="hidden" />
							<i :class="`nucleo ${item.iconName} text-gray-3`"></i>
							<label class="flex-auto cursor-pointer" :for="item.iconName"></label>
						</div>
					</div>
				</div>

				<!-- listDefaultKpis -->
				<!-- <div class="mt-5">
					<label for class="vs-input--label">{{ $t("DeviceKpi") }}:</label>
					<v-select
						multiple
						class="select-multiple"
						:placeholder="`${$t('Actions.Choose')} ${$t('DeviceKpi').toLowerCase()}`"
						v-model="kpiv2Details"
						:reduce="kpi => ({ id: kpi.id })"
						label="name"
						name="kpi"
						:options="listDefaultKpis"
					>
						<template v-slot:option="option">
							<div>
								{{ option.name }}
							</div>
						</template>
						<span slot="no-options">{{ $t("Notify.NoMatchingOptions") }}</span>
					</v-select>
				</div> -->
			</div>
		</PerfectScrollbar>

		<div class="flex justify-center" slot="footer">
			<vs-button class="w-full sm:w-1/3 font-bold" @click.stop="submitData">{{ $t("Actions.Submit") }}</vs-button>
		</div>
	</el-dialog>
</template>

<script>
import _ from "lodash";
import vSelect from "vue-select";
import { mapGetters } from "vuex";
import constant from "@/utils/constant";

export default {
	props: {
		isPopupActive: {
			type: Boolean,
			required: true
		},
		data: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			dataId: null,
			dataName: "",
			categoryIcon: null,
			parentCategoryId: null,
			// kpiv2Details: null,

			initFormData: {},
			isFormDirty: false,

			categoryIcons: constant.CATEGORY_ICONS || [],

			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6
			}
		};
	},
	watch: {
		isPopupActive(val) {
			if (!val) return;

			const { id, name, parent_id, properties } = this.data;
			const parsedProperties = properties ? JSON.parse(properties) : {};
			const categoryIcon = _.get(parsedProperties, "icon") || this.defaultCategoryIcon;

			this.parentCategoryId = parent_id || null;
			if (!this.data.id) {
				this.initValues();
			} else {
				this.dataId = id;
				this.dataName = name;
				this.categoryIcon = categoryIcon;
				// this.kpiv2Details = kpiv2s;
			}

			this.isFormDirty = false;
			this.initFormData = {
				dataId: this.dataId,
				dataName: this.dataName,
				categoryIcon: this.categoryIcon,
				parentCategoryId: this.parentCategoryId
				// // kpiv2Details: this.kpiv2Details
			};
		},
		computedFormData: {
			handler: function(newVal) {
				if (!this.isFormDirty && !_.isEqual(newVal, this.initFormData) && newVal.dataId === this.initFormData.dataId) {
					this.isFormDirty = true;
				}
			},
			deep: true
		}
	},
	methods: {
		initValues() {
			if (this.data.id) return;
			this.dataId = null;
			this.dataName = "";
			this.categoryIcon = this.defaultCategoryIcon;
			this.parentCategoryId = null;
			// this.kpiv2Details = null;
			this.$validator.reset();
		},
		handleCreateOrUpdateSuccess() {
			this.initValues();
			if (this.dataId) {
				this.$emit("closePopup");
			}
			this.isFormDirty = false;
			this.$helper.notifySuccess({
				context: this,
				options: {
					text: this.$t(`${this.dataId ? "UpdateCategorySuccessful" : "CreateCategorySuccessful"}`)
				}
			});
		},
		async handleCreateOrUpdateCategory(dataObj) {
			try {
				this.$vs.loading();
				if (this.dataId) {
					await this.$store.dispatch("deviceManagement/updateCategory", {
						...dataObj,
						id: this.dataId
					});
				} else {
					await this.$store.dispatch("deviceManagement/addCategory", dataObj);
				}

				this.handleCreateOrUpdateSuccess();
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},
		submitData() {
			this.$validator.validateAll().then(result => {
				if (result) {
					const dataObj = {
						name: this.dataName,
						parent_id: this.parentCategoryId
						// kpiv2_details: this.kpiv2Details
					};
					if (this.categoryIcon) {
						dataObj.properties__icon = this.categoryIcon;
					}
					this.handleCreateOrUpdateCategory(dataObj);
				}
			});
		}
		// setExpanded: (key, value) => obj => {
		//   const inner = obj => {
		//     if(obj.hasOwnProperty(key)) obj.state = {expanded: true}
		//     else obj.children.forEach(inner)
		//   }

		//   return inner(obj)
		// }
	},
	computed: {
		isPopupActiveLocal: {
			get() {
				return this.isPopupActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closePopup");
				}
			}
		},
		...mapGetters({
			getFormattedFlattenTreeCategories: "deviceManagement/getFormattedFlattenTreeCategories"
		}),
		categoryChoices() {
			return (this.getFormattedFlattenTreeCategories || []).map(category => ({
				value: category.id,
				text: category.name,
				depth: category.depth
			}));
		},
		computedFormData() {
			return {
				dataId: this.dataId,
				dataName: this.dataName,
				categoryIcon: this.categoryIcon,
				parentCategoryId: this.parentCategoryId
			};
		},
		defaultCategoryIcon() {
			return _.get(this.categoryIcons, "0.iconContent") || null;
		},
		listDefaultKpis() {
			return this.$store.state.deviceManagement.kpi;
		}
	},
	components: {
		vSelect
	}
};
</script>

<style lang="scss" scoped>
::v-deep header {
	&.vs-popup--header {
		h3 {
			text-transform: uppercase;
		}
	}
}

.custom-nested-dialog ::v-deep .el-dialog {
	.category-icons {
		.item {
			width: 54px;
			height: 54px;
			position: relative;
			margin-bottom: 8px;
			margin-right: 8px;

			label {
				position: relative;
				border: 1px solid #e0e0e0;
			}

			i.nucleo {
				position: absolute;
				color: #979797 !important;
				left: 50%;
				top: 50%;
				transform: translate(-50%, -50%);
				font-size: 22px;
				background-color: var(--color-white);
			}

			input[type="radio"]:checked {
				& ~ label {
					border-color: var(--color-solid-primary);
					border-width: 2px;
				}

				& ~ i.nucleo {
					z-index: 2;
				}
			}
		}
	}
}
</style>
